import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import styles from "./style.scss";
import {
  FinancialChartReference,
  MacroChartReference,
  MacroIrChartReference
} from "models/AiResearch";
import {
  formatDateString,
  formatThousandthsDigits
} from "components/AiResearch/utils/chartsFormat";

export interface Props {
  reference:
    | FinancialChartReference
    | MacroIrChartReference
    | MacroChartReference;
  onClick: () => void;
}

export const Graph: React.FC<Props> = ({ reference, onClick }) => {
  const seriesList = reference.data.content.series;

  const options: Highcharts.Options = {
    title: {
      text: ""
    },
    yAxis: {
      title: undefined,
      gridLineWidth: 1,
      tickAmount: 4,
      tickPixelInterval: 20,
      labels: {
        formatter() {
          return formatThousandthsDigits(this.value, seriesList);
        },
        style: {
          fontSize: "5px"
        }
      }
    },
    xAxis: {
      title: undefined,
      categories:
        seriesList[0]?.values.map(value => formatDateString(value.x)) ?? [],
      labels: {
        style: {
          fontSize: "5px"
        }
      },
      gridLineWidth: 1,
      gridLineColor: "#e6e6e6"
    },
    tooltip: {
      headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
      pointFormatter() {
        const formattedValue = formatThousandthsDigits(this.y, seriesList);
        return `<span style="color:${this.color}">\u25CF</span>：<b>${formattedValue}</b><br/>`;
      }
    },
    series: seriesList.map(series => ({
      type:
        reference.dataType === "macro_ir_chart" ||
        reference.dataType === "corporate_ir_chart"
          ? "column"
          : reference.dataType === "macro_chart"
          ? "line"
          : reference.data.content.chartType,
      data: series.values.map(value => value.y),
      name: series.name,
      connectNulls: true
    })),
    chart: {
      height: 108,
      width: 182
    },
    exporting: {
      enabled: false
    },
    legend: {
      enabled: false // 凡例非表示
    },
    credits: {
      enabled: false
    }
  };

  return (
    <div className={styles.container} onClick={onClick}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};
